import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref, watch } from 'vue';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

interface IProps {
  title?: string;
  text?: string;
  elevation?: string | number;
  somenteIcone?: boolean;
  expandido?: boolean;
}

interface IEmits {
  (event: 'change:expandido', e: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardExpand',
  props: {
    title: { default: '' },
    text: { default: '' },
    elevation: { default: 2 },
    somenteIcone: { type: Boolean, default: false },
    expandido: { type: Boolean, default: false }
  },
  emits: ["change:expandido"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'change:expandido', e: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, text: string, elevation: string | number, somenteIcone: boolean, expandido: boolean };





const show = ref<boolean>(true);

onBeforeMount(() => {
  show.value = props.expandido;
});

const verMais = 'Ver mais';
const verMenos = 'Ver menos';

watch(show, async (newValue, oldValue) => {
  if (newValue != oldValue) {
    emit('change:expandido', newValue);
  }
});

watch(
  () => props.expandido,
  async (newValue, oldValue) => {
    if (newValue != oldValue) {
      show.value = newValue;
    }
  },
  { deep: true }
);

return { __sfc: true,props, emit, show, verMais, verMenos, mdiChevronDown, mdiChevronUp }
}

})